import invoice from '@/api/invoice'
import receipt from '@/api/receipt'
import creditDay from '@/api/default-credit-day'
import exchangeRate from '@/api/exchange-rate'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  defaultCreditDay: 0,
  showData: {},
  branch_id: null,
  exchangeRate: 0,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().add(7, 'Day').format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SHOW_DATA (state, data) {
    state.showData = data
  },
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_DEFAULT_CREDIT_DAY (state, numberDay) {
    state.defaultCreditDay = numberDay
  },
  SET_EXCHANGE_RATE (state, exchangeRate) {
    state.exchangeRate = exchangeRate
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return receipt.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  fetchInvoice (context, attrubutes = {}) {
    let params = Object.assign(
      {
        search: context.state.search
      },
      attrubutes
    )
    return receipt.studentReceipt({ params })
  },
  async find (context, id) {
    if (_.isEmpty(context.state.showData)) {
      let response = await receipt.find(id)
      context.commit('SET_SHOW_DATA', response.data)
    }
  },
  store (context, data) {
    return receipt.store(data)
  },
  async getDefaultCreditDay (context, attrubutes = {}) {
    if (!context.state.defaultCreditDay > 0) {
      let response = await creditDay.get({
        params: attrubutes,
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      })
      context.commit('SET_DEFAULT_CREDIT_DAY', response.data[0].credit_day)
    }
  },
  async getExchangeRate (context, attrubutes = {}) {
    if (!context.state.exchangeRate > 0) {
      let response = await exchangeRate.get({
        params: {
          fields: {
            setup_currency_exchange_rates: 'exchange_rate'
          },
          filter: {
            first_row: null
          },
          page: -1
        },
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      })
      context.commit('SET_EXCHANGE_RATE', response.data[0].exchange_rate)
    }
  },
  pdf (context, id) {
    return receipt.previewPDF(id)
  },
  formViewModel (context, params) {
    return receipt.formViewModel({ params })
  }
}
